import { setupCustomElement } from './common/createCustomElement';

setupCustomElement();
